<template>
    <el-tabs>
        <el-tab-pane label="Certificate">
            <el-button type="primary" v-if="awards.length > 0" @click="$emit('export', 'showTotal')"
                size="medium" style="margin-bottom: 10px;">Download the certificate</el-button>
            <p v-if="showNoAwards" style="margin-left: 20px;">You did not receive an award for this competition</p>
            <div id="showTotal">
                <div v-for="(item, index) in awards" :key="index" class="certContainer16"
                    style="margin-bottom:10px;">
                    <img src="../../../assets/image/aeo_cert.png" class="modelCert" />
                    <div class="student">{{ studentName }}</div>
                    <div class="school">{{ accountName }}</div>
                    <div class="award">{{ item.award_lable }}</div>
                    <div v-if="item.award_set_note" class="award-set-note">
                        {{ item.award_set_note }}
                    </div>
                </div>
            </div>
        </el-tab-pane>
        <el-tab-pane label="Transcript">
            <el-button type="primary" @click="$emit('export', 'showTranscript')" size="medium"
                style="margin-bottom: 10px;">Download the transcript</el-button>
            <div id="showTranscript">
                <div v-for="(item, index) in transcripts" :key="index" class="transcriptContainer2"
                    style="margin-bottom:10px;">
                    <img :src="projectInfo.vertical_transcript" class="model_p" />
                    <div class="name">{{ studentName }}</div>
                    <div class="account">{{ accountName }}</div>
                    <div class="object_score">{{ item.object_exam_score }}</div>
                    <div class="case_score">{{ item.case_score }}</div>
                    <div class="total_score">{{ item.total_score }}</div>
                </div>
            </div>
        </el-tab-pane>
    </el-tabs>
</template>

<script>
export default {
    name: 'AwardAEO',
    props: {
        awards: Array,
        transcripts: Array,
        studentName: String,
        accountName: String,
        projectInfo: Object,
        showNoAwards: Boolean
    }
}
</script>

<style lang="scss" scoped>
.certContainer16 {
    position: relative;

    .modelCert {
        width: 297mm;
        height: 208.7mm;
    }

    .student {
        position: absolute;
        top: 300px;
        width: 297mm;
        font-size: 35px;
        font-weight: 600;
        text-align: center;
    }

    .school {
        width: 297mm;
        position: absolute;
        top: 350px;
        text-align: center;
        font-size: 28px;
        font-weight: 350;
    }

    .award {
        width: 297mm;
        position: absolute;
        top: 435px;
        text-align: center;
        font-size: 32px;
        font-weight: 500;
    }

    .award-set-note {
        width: 297mm;
        position: absolute;
        top: 490px;
        background: white;
        border: 1px solid #333;
        padding: 15px;
        margin: 0 20px;
        box-sizing: border-box;
        font-size: 16px;
        line-height: 1.4;
        text-align: left;
    }
}

.transcriptContainer2 {
    position: relative;

    .model_p {
        width: 210mm;
        height: 295mm;
    }

    .name {
        position: absolute;
        width: 210mm;
        top: 480px;
        font-size: 42px;
        font-weight: 500;
        text-align: center;
    }

    .account {
        text-align: center;
        width: 210mm;
        position: absolute;
        top: 540px;
        font-size: 30px;
        font-weight: 400;
    }

    .object_score {
        position: absolute;
        top: 695px;
        left: 130px;
        font-size: 18px;
        font-weight: 400;
    }

    .case_score {
        position: absolute;
        top: 695px;
        left: 350px;
        font-size: 18px;
        font-weight: 400;
    }

    .total_score {
        position: absolute;
        top: 695px;
        left: 575px;
        font-size: 18px;
        font-weight: 400;
    }
}
</style>
